import { IEquipmentInventory } from "../../../components/FacilityManager/Domain/Types/FloorPlan/Equipment.type";
import { useRemoteQuery } from "../useRemote/useRemoteQuery";

export function useRemoteFetchBookableEquipments(enabled?: boolean) {
  return useRemoteQuery<IEquipmentInventory[]>({
    queryKey: "bookable-equipment",
    url: "/bookable-equipment",
    enabled: enabled ?? true
  });
}
